/*
  EInvoiceDialog.jsx — IRN + QR post-issue update dialog for Tax Invoices.
  Extracted from InvoicesPanel.jsx (Feb 2026 refactor).
*/
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { QrCode, Loader2 } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";

export default function EInvoiceDialog({
  open, onOpenChange, target, form, setForm, saving, onSave,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[560px]" data-testid="einvoice-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <QrCode className="w-4 h-4 text-[#0066CC]" /> E-Invoice Details
          </DialogTitle>
          <DialogDescription className="text-xs">
            Add / update the IRN Number and signed QR payload for{" "}
            <strong className="font-mono">{target?.invoice_no || "—"}</strong>.
            Values are printed on the Tax Invoice PDF automatically.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">IRN Number <span className="text-slate-400">(64 characters from GSTN IRP)</span></Label>
            <Input
              value={form.irn_number}
              onChange={e => setForm({ ...form, irn_number: e.target.value })}
              className="h-9 text-xs font-mono"
              placeholder="d1e2c3b4a5f6g7h8..."
              data-testid="einvoice-irn"
            />
          </div>
          <div>
            <Label className="text-xs">QR Code Data <span className="text-slate-400">(signed JSON / URL from IRP)</span></Label>
            <Textarea
              value={form.qr_code_data}
              onChange={e => setForm({ ...form, qr_code_data: e.target.value })}
              rows={4}
              className="text-xs font-mono"
              placeholder="eyJhbGciOiJSUzI1NiJ9..."
              data-testid="einvoice-qr"
            />
            <p className="text-[10px] text-slate-500 mt-1">Server will render this string as a QR code image on the invoice.</p>
          </div>
          {form.qr_code_data && (
            <div className="p-3 border rounded bg-white flex justify-center">
              <QRCodeSVG value={form.qr_code_data} size={140} level="M" />
            </div>
          )}
          <div className="flex justify-end gap-2 pt-2 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>Cancel</Button>
            <Button onClick={onSave} disabled={saving} className="bg-[#0066CC] hover:bg-[#0052A3]" data-testid="einvoice-save-btn">
              {saving ? <><Loader2 className="w-4 h-4 animate-spin mr-1" /> Saving…</> : "Save"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
